module.exports = __webpack_public_path__ + "cf7915737bd11c19193b8abe76a7fd67.jpg";